import React, { Component } from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  size?: 'default' | 'lg' | 'xl';
  href?: string;
  scrollToId?: string;
  variant?: 'primary' | 'white';
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  size = 'default',
  href,
  scrollToId,
  variant = 'primary'
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 active:translate-y-0 focus:outline-none focus:ring-4 uppercase tracking-wide';
  const sizeStyles = {
    default: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-6 py-4 text-lg md:text-xl'
  };
  const variantStyles = {
    primary: 'bg-emerald-500 hover:bg-emerald-600 text-white border-b-4 border-emerald-700 hover:border-emerald-800 focus:ring-emerald-300',
    white: 'bg-white hover:bg-gray-100 text-emerald-700 border-b-4 border-gray-300 hover:border-gray-400 focus:ring-gray-300'
  };
  const handleClick = (e: React.MouseEvent) => {
    if (scrollToId) {
      e.preventDefault();
      const element = document.getElementById(scrollToId);
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        // Center the element vertically in the viewport
        const viewportHeight = window.innerHeight;
        const offset = viewportHeight / 2 - 60;
        window.scrollTo({
          top: absoluteElementTop - offset,
          behavior: 'smooth'
        });
      }
    }
  };
  const Component = href ? 'a' : 'button';
  const props = href ? {
    href,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: handleClick
  } : {
    onClick: handleClick
  };
  return (
    // @ts-ignore
    <Component {...props} className={`
        ${baseStyles}
        ${sizeStyles[size]}
        ${variantStyles[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-187">
      <span data-id="element-188">{children}</span>
      <ArrowRight className="ml-2 h-5 w-5 animate-pulse" data-id="element-189" />
    </Component>
  );
}